import { createCustomIcon } from './utils/createCustomIcon';

const PinterestIcon = createCustomIcon({
  displayName: 'PinterestIcon',
  children: (
    <>
      <path
        d="M11.9995 11L7.99951 21"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.97319 16.5729C10.5926 16.8478 11.2782 17.0005 11.9995 17.0005C14.7609 17.0005 16.9995 14.7619 16.9995 12.0005C16.9995 9.23907 14.7609 7.00049 11.9995 7.00049C9.23809 7.00049 6.99951 9.23907 6.99951 12.0005C6.99951 12.9113 7.24318 13.7651 7.66872 14.5005"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="currentColor"
      />
    </>
  ),
});

export default PinterestIcon;
